import {HTMLAttributes} from 'react';
import {twMerge} from '../../../common/twMerge';
import {DayOfWeekSectionColumn} from './DayOfWeekSectionColumn';
import {DayOfWeekSectionSingleCategory} from './DayOfWeekSectionSingleCategory';

interface Props extends HTMLAttributes<HTMLDivElement> {}

export const DayOfWeekSection = ({className, ...rest}: Props) => {
  return (
    <div
      className={twMerge(
        'flex justify-center items-start gap-4pxr',
        'px-11pxr',
        className
      )}
      {...rest}
    />
  );
};

DayOfWeekSection.Column = DayOfWeekSectionColumn;
DayOfWeekSection.SingleCategory = DayOfWeekSectionSingleCategory;
